import React, { Component, Fragment } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { hashHistory } from 'react-router';
import { findDOMNode } from 'react-dom';
import { first, cloneDeep, keys, orderBy } from 'lodash';
import { injectIntl } from "react-intl";

import { modifyPageLayoutComponents } from '../PageLayout';
import template from './Fabricators.rt';
import { logout } from '../../actions';
import {
  getFabricators, changeFabricatorStatus, getCloneFabricatorFeatures, setCloningFeaturesSelection,
  cloneFeatures, cloneFabricatorChangeGroup, CloningGroupNameAll,
  cloneFabFeaturesReset, cloneFabricatorNew
} from './FabricatorsActions';
import { changeEmployeeStatus } from "./../Employees/EmployeesActions";
import {
  showAssignEntityPopup,
  showFabricatorsExportPopup,
  assignEntityPopupResetStatus,
  showImportFabricatorPopup,
  messageBox_Show
} from './../../actions/A_Popups';
import FabricatorHeader from './FabricatorsHeader';
import { AccessRights } from './../../schemas/accessRightsModel';
import { cloningGetFeaturesFromGroup } from "./FabricatorsReducer";
import { PARTS } from './../../schemas/accessRightsModel';
import * as Misc from '../../misc';
import {AutoSizer, List} from "react-virtualized";
import BlueDropDown from "../PageLayout/DropDowns/BlueDropDown";
import FabricatorsFeaturesFilters from "./FabricatorsFilters";
import FabricatorsCloneFeature from "./FabricatorsCloneFeature";

const mapStateToProps = state => {
  const { fabricators, auth } = state;
  const groupNames = keys(fabricators.cloningFabFeaturesGroups);
  groupNames.sort();
  const {selectedFilters} = state.featuresFiltersState;

  return {
    fabricators: fabricators.data.rows,
    page: fabricators.data.page,
    totalPages: fabricators.data.totalPages,
    ...fabricators,
    cloningFabFeaturesGroups: [CloningGroupNameAll].concat(groupNames),
    cloningFabFeaturesGroupsObjects: fabricators.cloningFabFeaturesGroups,
    userRoles: auth.roles,
    AR: AccessRights.get(state),
    selectedFilters,
  }
};

const mapDispatchToProps = dispatch => ({
  dispatch,
  getFabricators: (page, limit, searchKeyword) => dispatch(getFabricators(page, limit, searchKeyword)),
  changeFabricatorStatus: (fabricatorId, enabled) => dispatch(changeFabricatorStatus(fabricatorId, enabled)),
  changeEmployeeStatus: (userId, fabricatorId, enabled, isPrimaryProfile) => dispatch((changeEmployeeStatus(userId, fabricatorId, enabled, isPrimaryProfile))),
  logout: () => dispatch(logout()),
  showAssignEntityPopup: config => dispatch(showAssignEntityPopup(config)),
  showFabricatorsExportPopup: config => dispatch(showFabricatorsExportPopup(config)),
  showImportFabricatorPopup: show => dispatch(showImportFabricatorPopup(show)),
  getCloneFabricatorFeatures: sourceFabricatorId => dispatch(getCloneFabricatorFeatures(sourceFabricatorId)),
  setCloningFeaturesSelection: selection => dispatch(setCloningFeaturesSelection(selection)),
  messageBox_Show: (show, type, title, message, buttons) => dispatch(messageBox_Show(show, type, title, message, buttons)),
  cloneFeatures: (fabricatorId, destinationFabricatorForCloning, copyFeaturesType, cb) => dispatch(cloneFeatures(fabricatorId, destinationFabricatorForCloning, copyFeaturesType, cb)),
  cloneFabricatorNew: request => dispatch(cloneFabricatorNew(request)),
  cloneFabricatorChangeGroup: newGroupName => dispatch(cloneFabricatorChangeGroup(newGroupName)),
  cloneFabFeaturesReset: () => dispatch(cloneFabFeaturesReset())
});

const ActionsDropDown_CopyFeaturesInfo = 'Copy Features Into...';
const ActionsDropDown_Clone = 'Clone';

const SelectionActionItems = ['Select All', 'Select None', 'Invert Selection'];

const CopyFeaturesType = [
  { name: 'Add All', value: 'addAll' },
  { name: 'Add New', value: 'addNew' },
  { name: 'Add & Overwrite', value: 'addOverwrite' }
]

class Fabricators extends Component {
  constructor(props) {
    super(props);

    let dropdownValues = [];
    if (props.AR.v(PARTS.HUB_BUTTON_EMPLOYEES) || props.AR.isSiteAdmin())
      dropdownValues.push('Employees');
    if (props.AR.v(PARTS.HUB_BUTTON_CUSTOMERS) || props.AR.isSiteAdmin())
      dropdownValues.push('Customers');
    if (/*props.AR.v(PARTS.HUB_BUTTON_STORES) ||*/ props.AR.isSiteAdmin())
      dropdownValues.push('Stores');

    this.state = {
      page: 0,
      expandedRowId: 0,
      showExpandedRow: false,
      showFabricatorPopup: false,
      showStoresPopup: false,
      showPermissionsPopup: false,
      showFabricatorsExportPopup: false,
      isDropDownOpened: false,
      activeUser: {},
      activeDropDownValue: 'Fabricators',
      dropdownValues,
      actionsDropDownItems: [
        ActionsDropDown_CopyFeaturesInfo,
        ActionsDropDown_Clone
      ],
      actionsDropDownSelectedItem: 'Actions',
      sourceFabricatorForCloning: null,
      dropdownRef: null,
      selectionActionItems: SelectionActionItems,
      selectedSelectionActionItem: '',
      destinationFabricatorForCloning: props.cloningFabFeaturesData
        ? first(props.cloningFabFeaturesData.fabricators).id : null,
      copyFeaturesType: CopyFeaturesType,
      selectedCopyFeaturesType: first(CopyFeaturesType),
      fabricatorIdActive: null,
      showCloneFabricatorDialog: false,
      cloneFabricatorOptions: {
        sourceFabricatorId: 0,
        fabricatorName: '',
        cloneStoneSupplier: true,
        cloneCategories: true,
        cloneFeaturesAndGroups: true,
        cloneGalleryImages: true,
        cloneGalleryImagesEnabled: true,
        cloneRelatedProducts: true,
        cloneRelatedProductsEnabled: true,
        cloneDisplayLogic: true,
        cloneDisplayLogicEnabled: true,
        cloneDefaultImages: true,
        cloneDefaultImagesEnabled: true,
        cloneInstallations: true,
        cloneInstallationsEnabled: true,
        cloneEmployees: true,
        cloneEmployeesPermissions: true,
        cloneEmployeesPermissionsEnabled: true
      }
    }
  }

  componentDidMount() {
    this.props.dispatch(assignEntityPopupResetStatus());
    this.props.getFabricators();
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.statusUpdateSuccess && nextProps.statusUpdateSuccess !== this.props.statusUpdateSuccess) {
      this.props.getFabricators(this.state.page, 50, this.props.searchKeyword);
      return;
    }

    if (!nextProps.cloneFabricatorInProgress
      && nextProps.cloneFabricatorInProgress !== this.props.cloneFabricatorInProgress) {
      this.props.messageBox_Show(true, 'system', 'Clone Fabricator',
        'A new fabricator [' + nextProps.cloneFabricatorAnswer.newFabricatorName + '] has been successfully created.');
      return;
    }
  }

  handleActivateEntity = (entityId, enabled) => {
    this.props.changeFabricatorStatus(entityId, !enabled);
  };

  handleCopyFeaturesTypeChanged = (item) => {
    this.setState({ selectedCopyFeaturesType: item });
  }

  handleActionDropDownChange = ({ item, fabricator }) => {
    switch (item) {
      case ActionsDropDown_CopyFeaturesInfo:
        this.setState({ actionsDropDownSelectedItem: item, sourceFabricatorForCloning: cloneDeep(fabricator) },
          () => {
            this.props.getCloneFabricatorFeatures(fabricator.id);
          });
        break;
      case ActionsDropDown_Clone:
        // this.props.cloneFabricator(fabricator.id);
        this.setState({
          showCloneFabricatorDialog: true,
          cloneFabricatorOptions: { ...this.state.cloneFabricatorOptions, sourceFabricatorId: fabricator.id }
        }
        );
        break;
    }
    this.setState({
      fabricatorIdActive: null
    });
  };

  dropdownToggleCallBack = (opened, fabricatorIndex) => {
    this.setState({
      fabricatorIdActive: opened ? fabricatorIndex : null
    });
  };

  handleSelectionActionDropDownChange = selectedSelectionActionItem => {
    this.setState({ selectedSelectionActionItem }, () => {
      let selection = '';
      if (selectedSelectionActionItem === SelectionActionItems[0])
        selection = 'all';
      else if (selectedSelectionActionItem === SelectionActionItems[1])
        selection = 'none';
      else if (selectedSelectionActionItem === SelectionActionItems[2])
        selection = 'invert';

      if (selection !== '')
        this.props.setCloningFeaturesSelection(selection);
    });
  }

  handleCloneFeaturesClick = () => {
    const cloneToFabName = this.props.cloningFabFeaturesData.fabricators.find(fab => fab.id === this.state.destinationFabricatorForCloning);
    const featuresAmount = this.props.cloningFabFeaturesData.features.filter(feature => feature.isChecked).length;
    this.props.messageBox_Show(true,
      'system',
      'Clone features',
      `You are going to clone <span class="message-system-text-green">${featuresAmount}</span> features from <span class="message-system-text-green">${this.state.sourceFabricatorForCloning.name}</span> to <span class="message-system-text-green">${cloneToFabName ? cloneToFabName.name : ""}</span>. Selected type: <span class="message-system-text-green">${this.state.selectedCopyFeaturesType.name}</span><br/><br/>
       Are you sure you want to start?`,
      [{
        text: 'Stop it, I am afraid!!!',
        onClick: () => this.props.messageBox_Show(false)
      },{
        text: 'Do it',
        color: "green",
        onClick: () => {
          this.props.messageBox_Show(false);
          this.props.cloneFeatures(this.state.sourceFabricatorForCloning.id,
            this.state.destinationFabricatorForCloning,
            this.state.selectedCopyFeaturesType.value,
            error => {
              if (!error) {
                this.setState({ actionsDropDownSelectedItem: 'Actions', sourceFabricatorForCloning: null })
              }
            });
        }
      }]
    )
  }

  handleBackToFabricatorsClick = () => {
    this.setState({ actionsDropDownSelectedItem: 'Actions', sourceFabricatorForCloning: null }, () => {
      this.props.cloneFabFeaturesReset();
    });
  }

  handleDestinationFabricatorOnChange = e => {
    this.setState({ destinationFabricatorForCloning: +e.target.value })
  }

  handleDropDownChange = (value) => {
    const opened = !this.state.isDropDownOpened;
    this.setState({ isDropDownOpened: opened }, () => {
      if (opened) {
        findDOMNode(this.state.dropdownRef).focus();
      }
    });

    if (value) {
      hashHistory.push(value.toLowerCase());
    }
  };

  handleShowPopup = (userId, popupName, nested) => {
    const { intl } = this.props;
    let activeUser;

    if (nested) {
      activeUser = this.props.fabricators.find(fab => fab.id === this.state.expandedRowId).users
        .find(user => user.id === userId)
    } else {
      activeUser = this.props.fabricators.find(fab => fab.id === userId)
    }

    const newState = { activeUser: activeUser };

    switch (popupName) {
      case "fabricators":
        this.props.showAssignEntityPopup({
          entityId: activeUser.id,
          entityType: 'fabricator',
          visible: true,
          entitiesType: 'fabricators',
          headerText: `${intl.formatMessage({ id: "assignEntityPopup.addFabricatorsToFabricator" })}: ${activeUser.name}`
        });
        break;
      case "stores":
        this.props.showAssignEntityPopup({
          entityId: activeUser.id,
          entityType: 'fabricator',
          visible: true,
          entitiesType: 'stores',
          headerText: `${intl.formatMessage({ id: "assignEntityPopup.addStoresToEmployee" })}: ${activeUser.name}`
        });
        break;
      case "permissions":
        newState.showPermissionsPopup = !this.state.showPermissionsPopup;
        break;
    }
    this.setState(newState);
  };

  handleClosePopup = (popupName, reload = false) => {
    const newState = {};
    switch (popupName) {
      case "fabricators":
        newState.showFabricatorPopup = false;
        break;
      case "stores":
        newState.showStoresPopup = !this.state.showStoresPopup;
        break;
      case "permissionsfabricator":
        newState.showPermissionsPopup = false;
        break;
      case "fabricatorsExport":
        newState.fabricatorsExport = false;
        break;
    }
    this.setState(newState);
    if (reload) {
      this.props.getFabricators();
    }
  };

  handleExpandRow = (expandedRowId) => {
    if (expandedRowId === this.state.expandedRowId) {
      this.setState({ showExpandedRow: !this.state.showExpandedRow });
    } else {
      this.setState({
        expandedRowId,
        showExpandedRow: true
      });
    }
  };

  handleRedirect = (entityId, clientType, clientSubType) => {
    let redirectUrl = "account";
    if (entityId && clientType) {
      redirectUrl += `?entityId=${entityId}&clientType=${clientType}`
    }
    if (!entityId && clientType) {
      redirectUrl += `?clientType=${clientType}`
    }
    if (clientSubType) {
      redirectUrl += `&clientSubType=${clientSubType}`
    }
    hashHistory.push(redirectUrl)
  };

  showImportDialog = (show = true) => {
    this.props.showImportFabricatorPopup(show);
  }

  showExportDialog = (show = true) => {
    this.props.showFabricatorsExportPopup({visible: show, fabricators: this.props.fabricators});
  }

  handlePaginate = (page) => {
    this.setState({ page: page - 1 });
    this.props.getFabricators(page - 1, 50, this.props.searchKeyword);
  };

  handleDropdownOnBlur = (e) => {
    this.setState({ isDropDownOpened: false });
  };

  setCloneFabricatorState(propName, e, value) {
    const { cloneFabricatorOptions } = this.state;

    if (e) {
      Misc.ignoreDefault(e);
      cloneFabricatorOptions[propName] = e.target.value;
    } else {
      cloneFabricatorOptions[propName] = value;
    }

    this.setState({ cloneFabricatorOptions: { ...cloneFabricatorOptions } });
    this.updateCloneFabricatorToggles();
  }

  updateCloneFabricatorToggles = () => {
    const { cloneFabricatorOptions } = this.state;
    cloneFabricatorOptions.cloneGalleryImagesEnabled = cloneFabricatorOptions.cloneFeaturesAndGroups;
    cloneFabricatorOptions.cloneRelatedProductsEnabled = cloneFabricatorOptions.cloneFeaturesAndGroups;
    cloneFabricatorOptions.cloneDisplayLogicEnabled = cloneFabricatorOptions.cloneFeaturesAndGroups;
    cloneFabricatorOptions.cloneDefaultImagesEnabled = cloneFabricatorOptions.cloneFeaturesAndGroups;
    cloneFabricatorOptions.cloneInstallationsEnabled = cloneFabricatorOptions.cloneFeaturesAndGroups;
    cloneFabricatorOptions.cloneEmployeesPermissionsEnabled = cloneFabricatorOptions.cloneEmployees;
    this.setState({ cloneFabricatorOptions: { ...cloneFabricatorOptions } });
  }

  cloneFabricatorNew = () => {
    const { cloneFabricatorOptions: opt } = this.state;

    const request = {
      sourceFabricatorId: opt.sourceFabricatorId,
      newFabricatorName: opt.fabricatorName,
      cloneItemTypes: {}
    }
    if (opt.cloneStoneSupplier) {
      request.cloneItemTypes.cloneStoneSupplier = true;
    }
    if (opt.cloneCategories) {
      request.cloneItemTypes.categories = true;
    }
    if (opt.cloneFeaturesAndGroups) {
      request.cloneItemTypes.featuresAndGroups = true;
      if (opt.cloneGalleryImages) {
        request.cloneItemTypes.galleryImages = true;
      }
      if (opt.cloneRelatedProducts) {
        request.cloneItemTypes.relatedProducts = true;
      }
      if (opt.cloneDisplayLogic) {
        request.cloneItemTypes.displayLogic = true;
      }
      if (opt.cloneDefaultImages) {
        request.cloneItemTypes.defaultImages = true;
      }
      if (opt.cloneInstallations) {
        request.cloneItemTypes.installations = true;
      }
    }
    if (opt.cloneEmployees) {
      request.cloneItemTypes.employees = true;
      if (opt.cloneEmployeesPermissions) {
        request.cloneItemTypes.permissions = true;
      }
    }

    this.setState({ showCloneFabricatorDialog: false });
    this.props.cloneFabricatorNew(request);
  }

  renderFabricatorsCloningList = () => {
    const {selectedFilters, cloningFabFeaturesSelectedGroup, cloningFabFeaturesSearchTerm, cloningFabFeaturesData,
      cloningFabFeaturesGroupsObjects} = this.props;
    const cloningFabFeaturesFromGroup = cloningGetFeaturesFromGroup({cloningFabFeaturesData, cloningFabFeaturesGroups: cloningFabFeaturesGroupsObjects},
      cloningFabFeaturesSelectedGroup, cloningFabFeaturesSearchTerm, selectedFilters
    );

    console.log("cloningFabFeaturesFromGroup", cloningFabFeaturesFromGroup);

    return (
      <Fragment>
        <div className="fabricators-lir fabricators-lir--with-filters">
          <div className="fabricators-col fabricators-col--no-border">
            <BlueDropDown items={this.state.selectionActionItems}
                          onItemClick={this.handleSelectionActionDropDownChange}
                          selectedItem={null}/>
            <BlueDropDown items={this.props.cloningFabFeaturesGroups}
                          onItemClick={this.props.cloneFabricatorChangeGroup}
                          selectedItem={this.props.cloningFabFeaturesSelectedGroup}/>
          </div>
          <FabricatorsFeaturesFilters fabricator={this.state.sourceFabricatorForCloning}/>
        </div>
        <div className="fabricators-container--cloning">
          <AutoSizer>
            {({width, height}) => this.props.cloningFabFeaturesData ? (
              <List width={width}
                    height={height}
                    rowCount={cloningFabFeaturesFromGroup.length}
                    rowHeight={48}
                    rowRenderer={({index, key, style}) => {
                      const feature = cloningFabFeaturesFromGroup[index];
                      if (!feature) {
                        return null
                      }
                      return <FabricatorsCloneFeature key={key || feature.id} feature={feature} style={style}/>
                    }} />
            ) : null}
          </AutoSizer>
        </div>
      </Fragment>
    )
  }

  render = template;

}

Fabricators.propTypes = {
  fabricators: PropTypes.array,
  page: PropTypes.number,
  totalPages: PropTypes.number,
  statusUpdateSuccess: PropTypes.bool,
  getFabricators: PropTypes.func.isRequired,
  changeFabricatorStatus: PropTypes.func.isRequired,
  cloneFabricatorNew: PropTypes.func.isRequired
};

const connector = connect(mapStateToProps, mapDispatchToProps);

export const FabricatorsLayoutComponents = modifyPageLayoutComponents({
  pageHeader: connector(FabricatorHeader),
  content: injectIntl(connector(Fabricators))
});

